<template>
  <div>
    <v-sheet >
      <v-row class="d-flex justify-center">
        <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">
          <v-card class="pa-2 ml-3">
            
              <ShopInfo :shop="shop" admin class="pa-2" />
            
          </v-card>
        </v-col>
        <v-col cols="9" class="ma-0 pa-0" v-if="$vuetify.breakpoint.smAndDown">
          <div class="d-flex justify-space-between align-center mt-4">
            <v-avatar>
              <img :src="shop.photograph" />
            </v-avatar>
            <v-btn
              tile
              outlined
              @click.stop="pagemenu = !pagemenu"
              class="ml-2 px-2"
            >
              <v-icon color="#4B2A66" class="pr-2">mdi-menu</v-icon>
              Painel Administrativo
            </v-btn>
          </div>
          <div class="d-flex justify-center">
            <v-btn
              v-if="shop.facebook_link"
              icon
              class="ma-2 mt-3"
              target="_blank" :href="$utils.processURL(shop.facebook_link)"
            >
              <v-icon size="30" color="blue">mdi-facebook</v-icon>
            </v-btn>
            <v-btn
              v-if="shop.instagram_link"
              icon
              class="ma-2 mt-3"
              target="_blank" :href="$utils.processURL(shop.instagram_link)"
            >
              <v-icon size="30" color="pink">mdi-instagram</v-icon>
            </v-btn>
            <v-btn
              v-if="shop.whatsapp_link"
              icon
              class="ma-2 mt-3"
              target="_blank" :href="$utils.processWhatsapp(shop.whatsapp_link)"
            >
              <v-icon size="30" color="green">mdi-whatsapp</v-icon>
            </v-btn>
            <v-btn
              v-if="shop.telephone"
              icon
              class="ma-2 mt-3"
              target="_blank" :href="shop.telephone"
            >
              <v-icon size="30">mdi-phone</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="9" lg="9" xl="9" class="pt-0">
          <router-view />
        </v-col>
      </v-row>
    </v-sheet>
    <div v-if="$vuetify.breakpoint.smAndDown">
      <v-navigation-drawer v-model="pagemenu" fixed>
        <ShopInfo :shop="shop" admin class="pa-2" />
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import ShopInfo from "@/components/ShopInfo.vue";

export default {
  name: "Main",
  components: {
    ShopInfo,
  },
  data: () => ({
    product: {
      name: "",
      description: "",
      category: "",
      value: undefined,
      promotional_value: null,
      images: [],
    },
    value: null,
    changingProducts: false,
    visible: false,
    productsQuery: "",
    loading: true,
    alertImage: false,
    visibleImage: false,
    visibleLogo: true,
    row: null,
    drawer: true,
    addproduct: false,
    pagemenu: false,
    shop: {},
    name_shop: "",
    id_shop: "",
    id_city: "",
    city: [],
    state: "",
    files: [],
    previewImage: null,
    save: true,
    saveAlteracoes: false,
    products: [],
  }),
  mounted() {
    this.$axios.get("/shop/" + this.$route.params.shop_url).then((response) => {
      this.shop = response.data;
      document.title = `Olhadela - ${this.shop.shop_name}`;
      if (this.$store.state.user.id != this.shop.user_id) {
        this.$router.replace({
          path: "/negocio/" + this.$route.params.shop_url,
        });
      } else {
        this.name_shop = response.data.shop_name;
        this.id_shop = response.data.id;
        this.id_city = response.data.city_id;
        this.$axios.get("/products/" + this.id_shop).then((response) => {
          this.products = response.data;
        });
        this.$axios.get("/city/" + this.id_city).then((response) => {
          this.city = response.data;
          this.$axios
            .get("/state/" + response.data.state_id)
            .then((response) => {
              this.state = response.data.uf;
            });
        });
        this.loading = false;
      }
    });
  },
};
</script>